import React from 'react';
import '../graphStyles.scss';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import NoDataFound from '../../NoDataFound';
import { ExportCSVButton } from '../../ExportCSVButton';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function VisitorsWhoBoughtAfterNudgesGraph({ visitorWhoSawNudge, loading }) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        labels: {
          font: {
            size: function () {
              if (window.innerWidth < 1050 && window.innerWidth > 767) {
                return 10;
              } else {
                return 13;
              }
            }
          }
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: 'Week',
          font: {
            size: function () {
              if (window.innerWidth < 1050 && window.innerWidth > 767) {
                return 10;
              } else {
                return 13;
              }
            }
          }
        },
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: function () {
              if (window.innerWidth < 1050 && window.innerWidth > 767) {
                return 10;
              } else {
                return 13;
              }
            }
          }
        }
      },
      y: {
        title: {
          display: true,
          text: 'Number of unique shoppers',
          font: {
            size: function () {
              if (window.innerWidth < 1050 && window.innerWidth > 767) {
                return 10;
              } else {
                return 13;
              }
            }
          }
        }
      },
      y1: {
        position: 'right',
        title: {
          display: true,
          text: '% of buyer from nudge',
          font: {
            size: function () {
              if (window.innerWidth < 1050 && window.innerWidth > 767) {
                return 10;
              } else {
                return 13;
              }
            }
          }
        },
      }
    },
  };

  const data = {
    labels: visitorWhoSawNudge.labels,
    datasets: [
      {
        label: 'Coupons shown and finally bought',
        data: visitorWhoSawNudge.couponsShownAndBought,
        backgroundColor: 'rgba(255, 100, 0, 0.99)',
        hoverBackgroundColor: 'rgba(255, 100, 0, 0.99)',
        order: 1,
      },
      {
        label: '% of buyer from add to cart nudge',
        data: visitorWhoSawNudge.percentOfBuyerFromNudge,
        type: 'line',
        borderColor: 'rgba(12, 150, 255, 0.99)',
        backgroundColor: 'rgba(12, 150, 255, 0.99)',
        hoverBackgroundColor: 'rgba(12, 150, 255, 0.99)',
        yAxisID: 'y1',
        lineTension: 0.2,
        order: 0
      },
      {
        label: '% of buyer from nudge shown',
        data: visitorWhoSawNudge.percentOfBuyerFromNudgeShown,
        type: 'line',
        borderColor: 'rgba(230, 210, 20, 0.99)',
        backgroundColor: 'rgba(230, 210, 20, 0.99)',
        hoverBackgroundColor: 'rgba(230, 210, 20, 0.99)',
        yAxisID: 'y1',
        lineTension: 0.2,
        order: 0
      }
    ],
  };

  const allData = [
    ['Percent of Buyer From Nudge', visitorWhoSawNudge.percentOfBuyerFromNudge],
    ['Coupons Shown and Finally Bought', visitorWhoSawNudge.couponsShownAndBought]
  ];

  return (
    <div className='graph'>
      <div className='graph__title flex justify-between items-center'>
        <h4 className="text-lg md:text-xl">Visitors who bought after seeing nudges</h4>
        <ExportCSVButton allData={allData} name={'Visitors_who_Bought_After_Seeing_Nudges'} />
      </div>
      {loading ? (
        <div className="loader flex-grow flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="185px" height="185px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" r="0" fill="none" stroke="#b927d4" strokeWidth="1">
              <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="0s"></animate>
              <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="0s"></animate>
            </circle>
            <circle cx="50" cy="50" r="0" fill="none" stroke="#32c5ff" strokeWidth="1">
              <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
              <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
            </circle>
          </svg>
        </div>
      ) : (
        <>
          {visitorWhoSawNudge.labels && visitorWhoSawNudge.labels.length !== 0 ? (
            <div className="relative h-80 md:h-96">
              <Bar className='chart' id='chart16' options={options} data={data} />
            </div>
          ) : (
            <NoDataFound />
          )}
        </>
      )}
    </div>
  );
}
